<template>
  <div class="ai-icon">
    <video autoplay loop muted playsinline>
      <source
        src="/static/promo-static/landing-2021/src/files/components/ai-icon/ai-icon.av1"
        type="video/mp4; codecs=av01.0.05M.08"
      />
      <source src="/static/promo-static/landing-2021/src/files/components/ai-icon/ai-icon.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VPricingTableIconAi',
};
</script>
